import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import statsApi from '../slices/statsApi';

import rootReducer from '../reducers';

function configure() {
  const store = configureStore({
    reducer: rootReducer,
    devTools: false,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(statsApi.middleware),
  });
  setupListeners(store.dispatch);

  return store;
}

export default configure;
